import * as fromDatatype from '../datatype-library/index';

export interface bl_mrp_container_size_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  x_dim: fromDatatype.NumericDatatypeInterface;
  x_uom: fromDatatype.VarcharDatatypeInterface;
  y_dim: fromDatatype.NumericDatatypeInterface;
  y_uom: fromDatatype.VarcharDatatypeInterface;
  z_dim: fromDatatype.NumericDatatypeInterface;
  z_uom: fromDatatype.VarcharDatatypeInterface;
  internal_dim: fromDatatype.NumericDatatypeInterface;
  internal_dim_uom: fromDatatype.VarcharDatatypeInterface;
  volume: fromDatatype.NumericDatatypeInterface;
  volume_uom: fromDatatype.VarcharDatatypeInterface;
  drum_type: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_mrp_container_size_RowClass implements bl_mrp_container_size_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  x_dim: fromDatatype.NumericDatatypeInterface;
  x_uom: fromDatatype.VarcharDatatypeInterface;
  y_dim: fromDatatype.NumericDatatypeInterface;
  y_uom: fromDatatype.VarcharDatatypeInterface;
  z_dim: fromDatatype.NumericDatatypeInterface;
  z_uom: fromDatatype.VarcharDatatypeInterface;
  internal_dim: fromDatatype.NumericDatatypeInterface;
  internal_dim_uom: fromDatatype.VarcharDatatypeInterface;
  volume: fromDatatype.NumericDatatypeInterface;
  volume_uom: fromDatatype.VarcharDatatypeInterface;
  drum_type: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}